export const title = "Proof — Your photos never expire";
